/**
 * DANI streams its reasoning twice (test1, 2026-10-16): as pieces while it
 * thinks (`response.thinking.delta`), then once more as the finished block
 * (`response.thinking`, the same text with a signature). Both carry
 * `content_index` and `text`, so the chat appended the block after its pieces
 * and every paragraph of "Thinking details" showed twice.
 *
 * One tracker per stream: a finished block whose pieces already arrived is a
 * repeat and is skipped; a finished block that came without pieces is kept.
 */
export const THINKING_DELTA_EVENT = 'response.thinking.delta';
export const THINKING_BLOCK_EVENT = 'response.thinking';

export function createThinkingRepeatFilter(): (
    event: string | null,
    data: Record<string, unknown>,
) => boolean {
    const streamed = new Set<unknown>();
    return (event, data) => {
        if (data.content_index === undefined) return false;
        if (event === THINKING_DELTA_EVENT) {
            streamed.add(data.content_index);
            return false;
        }
        return event === THINKING_BLOCK_EVENT && streamed.has(data.content_index);
    };
}
